import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const tabsContainerStyle = () => ({
	container: {
		width: '100%',
		margin: '0px',
	},
	tabsButtons: {
		display: 'flex',
		flexDirection: 'row-reverse',
		marginTop: 24,
		'& > :first-child': {
			margin: '0 0 0 8px',
		},
	},
	right: {
		textAlign: 'right',
	},
	nextButton: {
		width: 120,
	},
	loadingWrapper: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		background: whiteColor,
		zIndex: 1000,
	},
});

export default tabsContainerStyle;
